module.exports = __webpack_public_path__ + "img/uoit.7af6ca08.png";